// extracted by mini-css-extract-plugin
export default {"warningIcon":"warningIcon__KTPoV","button":"button__jWMez","buttonWrapper":"buttonWrapper__AZxK5"};